import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../data/gridColumnType";

const initState = {
  roleName: '',
  roleDescription: '',
  isActive: '',
}

const FormData = {
  name: "Role Management",
  initialState: initState,

  section: [
    {
      sectionId: 'RoleManagement',
      title: "Role Management Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "roleName",
          label: "Role Name",
          Field_Name: "role name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "roleName",
          fieldSetting: {
            placeholder: "Please Enter Role Name",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "roleDescription",
          label: "Role Description",
          Field_Name: "role description",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "roleDescription",
          fieldSetting: {
            placeholder: "Please Enter Role Description",
            allowSpace: true,
            isDisable: false,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2 double-label-sec checkbox-style",
          },
        },
      ]
    }
  ]
}

export const RoleGridConfig = {
  columns: [
    {
      name: "Role Name",
      fieldName: "roleName",
      colStyle: {
        width: "30%",
        textAlign: "center",
      },
    },
    {
      name: "Role Description",
      fieldName: "roleDescription",
      colStyle: {
        width: "30%",
        textAlign: "center",
      },
    },

    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
        // allowPermission:true,
        // allowUser:true,
      },
      colStyle: {
        width: "15%",
        textAlign: "center",
      },
      customAction: [
        {
          name: "USER",
          iconClass: "gridicons:user",
        },
        {
          name: "PERMISSION",
          iconClass: "ph:key",
        },
      ],
     
    },
  ],
};

export default FormData;
